import { TenantFuelCardSetInputModel } from '@ail/orders-api'
import 'nouislider/distribute/nouislider.css'
import React from 'react'
import { withTranslation } from 'react-i18next'
import { IFuelCardViewModel } from '../../../types/interfaces'
import './FuelCard.scss'

interface IFuelCardProps {
  managementFuelCard?: IFuelCardViewModel
  input?: boolean
  set?: TenantFuelCardSetInputModel
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

class FuelCard extends React.Component<IFuelCardProps> {
  constructor(props: IFuelCardProps) {
    super(props)
  }

  public render() {
    const fuelCard = this.props.managementFuelCard
    const logos = fuelCard?.key.split('-')
    return (
      <>
        <div className={`fuelCard ${fuelCard?.electric && 'electric'}`}>
          <div className="FuelCardInfo">
            <div className="fuelArea">
              {fuelCard?.key !== 'none' ? (
                logos?.map((q) => (
                  <img
                    src={
                      '/' +
                      (q?.indexOf(' ') >= 0 ? q?.substr(0, q?.indexOf(' ')).toLowerCase() : q?.toLowerCase()) +
                      '.svg'
                    }
                    onError={(e) => this.dumbIcon(e)}
                  />
                ))
              ) : (
                <i className="icon-fuelcard-no" />
              )}
            </div>
            <div className="cardFeatures">
              {this.props.input && (
                <input
                  type="checkbox"
                  className="fuelCheck"
                  checked={!!fuelCard?.id && this.props.set?.fuelCards?.includes(fuelCard?.id)}
                  name={fuelCard?.name}
                  value={fuelCard?.id}
                  onChange={(e) => this.props.onInputChange && this.props.onInputChange(e)}
                />
              )}
              {fuelCard?.electric && <i className="icon-fuelcard-electric" />}
              {fuelCard?.carwash && <i className="icon-car-wash" />}
            </div>
            {fuelCard?.key !== 'none' && (
              <img
                src={`/${fuelCard?.name?.toLowerCase().includes('international') ? 'international' : 'national'}.svg`}
                className="locImg"
              />
            )}
            <div className={`fuelBrand ${fuelCard?.key === 'none' && 'noFuelCard'}`}>{fuelCard?.name || '-'}</div>
          </div>
        </div>
      </>
    )
  }

  private dumbIcon(e: React.SyntheticEvent<HTMLImageElement>) {
    e.currentTarget.src = '/makesLogos/dummy.svg'
  }
}
// eslint-disable-next-line react-refresh/only-export-components
export default withTranslation('common')(FuelCard)
